/* TERRA:APIS — căutare în Apipedia (doar articole).
   Sugestii live din /search/suggest.json cu resources[type]=article.
   Trimiterea formularului duce la /search?view=apipedia&type=article&q=...
   Folosit de snippets/terraapis-apipedia-search-form.liquid. */
(function () {
  if (customElements.get('apipedia-search')) return;

  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var stripHtml = function (s) {
    return String(s == null ? '' : s)
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;|&#160;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim();
  };
  // Fără diacritice și cu litere mici, pentru potrivire („menopauza” găsește „menopauză”).
  var fold = function (s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  };
  var highlight = function (text, term) {
    text = String(text == null ? '' : text);
    var foldedText = fold(text);
    var foldedTerm = fold(term);
    if (!foldedTerm || foldedText.length !== text.length) return escapeHtml(text);
    var idx = foldedText.indexOf(foldedTerm);
    if (idx === -1) return escapeHtml(text);
    var end = idx + foldedTerm.length;
    return escapeHtml(text.slice(0, idx)) + '<mark>' + escapeHtml(text.slice(idx, end)) + '</mark>' + escapeHtml(text.slice(end));
  };
  var thumb = function (url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=200';
  };
  var shorten = function (s, max) {
    if (s.length <= max) return s;
    return s.slice(0, max).replace(/\s+\S*$/, '') + '…';
  };

  class ApipediaSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.apipedia-search__results');
      this.status = this.querySelector('.apipedia-search__status');
      this.resetBtn = this.querySelector('.apipedia-search__reset');
      if (!this.form || !this.input || !this.results) return;

      this.suggestUrl = (this.dataset.suggestUrl || '/search/suggest') + '.json';
      this.limit = parseInt(this.dataset.limit, 10) || 6;
      this.minChars = 2;
      this.cache = Object.create(null);
      this.controller = null;
      this.timer = null;
      this.term = '';
      this.text = {
        heading: this.dataset.textHeading || 'Articole din Apipedia',
        all: this.dataset.textAll || 'Vezi toate rezultatele pentru „%s”',
        empty: this.dataset.textEmpty || 'Nu am găsit articole pentru „%s”.',
        count: this.dataset.textCount || '%s articole sugerate',
      };

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      if (this.resetBtn) this.resetBtn.addEventListener('click', this.reset.bind(this));
      // Clicul pe o sugestie nu scoate focusul din câmp (altfel lista s-ar închide înainte de navigare).
      this.results.addEventListener('mousedown', function (e) { e.preventDefault(); });
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this));
      this.toggleReset();
    }

    onInput() {
      this.toggleReset();
      var term = this.input.value.trim();
      clearTimeout(this.timer);
      if (term.length < this.minChars) {
        this.term = term;
        this.abort();
        this.close();
        return;
      }
      this.timer = setTimeout(this.lookup.bind(this, term), 250);
    }

    onFocus() {
      var term = this.input.value.trim();
      if (term.length >= this.minChars && this.cache[fold(term)]) this.render(this.cache[fold(term)], term);
    }

    onFocusOut() {
      var self = this;
      setTimeout(function () {
        if (!self.contains(document.activeElement)) self.close();
      }, 0);
    }

    onDocumentClick(e) {
      if (!this.contains(e.target)) this.close();
    }

    abort() {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
    }

    lookup(term) {
      var self = this;
      this.term = term;
      var key = fold(term);
      if (this.cache[key]) {
        this.render(this.cache[key], term);
        return;
      }
      this.abort();
      this.controller = new AbortController();
      var params = new URLSearchParams({
        q: term,
        'resources[type]': 'article',
        'resources[limit]': String(this.limit),
        'resources[options][prefix]': 'last',
        'resources[options][fields]': 'title,body,tag',
      });
      this.setAttribute('loading', '');
      fetch(this.suggestUrl + '?' + params.toString(), { signal: this.controller.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var items = (data && data.resources && data.resources.results && data.resources.results.articles) || [];
          self.cache[key] = items;
          if (self.term === term) self.render(items, term);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          self.close();
        })
        .then(function () {
          self.removeAttribute('loading');
        });
    }

    render(items, term) {
      var self = this;
      var html = '';
      if (items.length) {
        html += '<p class="apipedia-search__heading">' + escapeHtml(this.text.heading) + '</p>';
        html += '<ul class="apipedia-search__list" role="group">';
        items.forEach(function (a, i) {
          var excerpt = shorten(stripHtml(a.summary_html || ''), 110);
          html +=
            '<li role="none"><a role="option" id="' + escapeHtml(self.input.id) + '-opt-' + i + '"' +
            ' class="apipedia-search__item" href="' + escapeHtml(a.url) + '" aria-selected="false" tabindex="-1">' +
            (a.image
              ? '<img class="apipedia-search__thumb" src="' + escapeHtml(thumb(a.image)) + '" alt="" loading="lazy" width="64" height="36">'
              : '<span class="apipedia-search__thumb" aria-hidden="true"></span>') +
            '<span class="apipedia-search__item-body">' +
            '<span class="apipedia-search__item-title">' + highlight(a.title, term) + '</span>' +
            (excerpt ? '<span class="apipedia-search__item-excerpt">' + escapeHtml(excerpt) + '</span>' : '') +
            '</span></a></li>';
        });
        html += '</ul>';
        html +=
          '<button type="submit" role="option" id="' + escapeHtml(this.input.id) + '-opt-all"' +
          ' class="apipedia-search__all" aria-selected="false" tabindex="-1">' +
          '<span>' + escapeHtml(this.text.all.replace('%s', term)) + '</span>' +
          '<span class="apipedia-search__arrow" aria-hidden="true">&rarr;</span></button>';
      } else {
        html += '<p class="apipedia-search__empty">' + escapeHtml(this.text.empty.replace('%s', term)) + '</p>';
      }
      this.results.innerHTML = html;
      this.open();
      this.announce(items.length ? this.text.count.replace('%s', items.length) : this.text.empty.replace('%s', term));
    }

    options() {
      return Array.prototype.slice.call(this.results.querySelectorAll('[role="option"]'));
    }

    onKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      var isOpen = this.hasAttribute('open');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!isOpen) {
          var t = this.input.value.trim();
          if (t.length >= this.minChars) this.lookup(t);
          return;
        }
        var opts = this.options();
        if (!opts.length) return;
        var i = -1;
        for (var k = 0; k < opts.length; k++) {
          if (opts[k].getAttribute('aria-selected') === 'true') { i = k; break; }
        }
        if (e.key === 'ArrowDown') i = (i + 1) % opts.length;
        else i = i <= 0 ? opts.length - 1 : i - 1;
        opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        this.input.setAttribute('aria-activedescendant', opts[i].id);
        return;
      }
      if (e.key === 'Enter' && isOpen) {
        var sel = this.results.querySelector('[role="option"][aria-selected="true"]');
        if (sel && sel.tagName === 'A') {
          e.preventDefault();
          window.location.href = sel.href;
        }
        // Butonul „Vezi toate” sau nicio selecție: formularul se trimite normal.
      }
    }

    onSubmit(e) {
      if (!this.input.value.trim()) {
        e.preventDefault();
        this.input.focus();
      }
    }

    open() {
      this.results.hidden = false;
      this.setAttribute('open', '');
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.results.hidden = true;
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    reset() {
      this.input.value = '';
      this.term = '';
      clearTimeout(this.timer);
      this.abort();
      this.close();
      this.toggleReset();
      this.input.focus();
    }

    toggleReset() {
      if (this.resetBtn) this.resetBtn.hidden = !this.input.value.length;
    }

    announce(msg) {
      if (this.status) this.status.textContent = msg;
    }
  }

  customElements.define('apipedia-search', ApipediaSearch);
})();
